/** ForaCare MeterID must be exactly 16 alphanumeric characters. */
export const FORACARE_METER_SERIAL_LENGTH = 16;

export const FORACARE_METER_SERIAL_ERROR =
  'Serial number must be exactly 16 letters and numbers.';

export function sanitizeForaCareMeterSerialInput(value) {
  return String(value ?? '')
    .replace(/[^a-zA-Z0-9]/g, '')
    .slice(0, FORACARE_METER_SERIAL_LENGTH);
}

export function normalizeForaCareMeterSerial(value) {
  const alphanumeric = String(value ?? '').replace(/[^a-zA-Z0-9]/g, '');
  return alphanumeric.length === FORACARE_METER_SERIAL_LENGTH ? alphanumeric : null;
}

/** Returns an error message, or null when valid / empty. */
export function getForaCareMeterSerialError(serial) {
  const raw = String(serial ?? '').trim();
  if (!raw) return null;
  if (!/^[a-zA-Z0-9]+$/.test(raw)) return 'Serial must contain letters and numbers only';
  if (raw.length !== FORACARE_METER_SERIAL_LENGTH) return FORACARE_METER_SERIAL_ERROR;
  return null;
}

/** MeterExID: 1–4; legacy "A"/"All" → 1 for ForaCare. */
export function normalizeForaCareMeterExtensionForSubmit(ext) {
  const raw = String(ext ?? '').trim().toUpperCase();
  if (!raw || raw === 'A' || raw === 'ALL') return '1';
  const n = Number.parseInt(raw, 10);
  if (Number.isFinite(n) && n >= 1 && n <= 4) return String(n);
  return '1';
}
